import { PlotCoreObject } from "./PlotCoreObject";
import { ObjectsPool } from './ObjectsPool';
import { IPlotsPool } from './interfaces';
import { ObjectType, AspObject } from './AspObject';
import * as aspSettings from './aspSettings';
import * as consts from '../common/consts';
import * as aspObjects from './aspObjects';
import { AppConfig } from '../app.config';

class PlotsPerSensor {
  objects: Map<number, PlotCoreObject> = new Map();
  correlated: Set<number> = new Set();
  // inManeuver: Set<number> = new Set();
}

var plotcount: number = 1;

export class PlotsCorePool extends ObjectsPool implements IPlotsPool {

  protected plotsPerSensor: Map<number, PlotsPerSensor> = new Map();

  constructor() {
    super(ObjectType.Plot, consts.MSG_TYPE_PLOT, aspSettings.plotsHistory(), true /* hookable */, true /* clickable */);
  }

  handleMsg(msgObj: any): void {
    if (AppConfig.settings.ShowLogs)
      console.log("plot msg:", msgObj);
    this.handlePlot(msgObj);
  }

  handlePlot(msgPlot: any) {
    let sensorID = 0;
    let correlated = false;
    if (msgPlot.Sic && msgPlot.Sac) {
      let sns = aspObjects.sensorsPool.getSensorBySicSac(msgPlot.Sic, msgPlot.Sac);
      if (sns)
        sensorID = sns.sensorID;
      else
        sensorID = aspObjects.sensorsPool.genSicSac(msgPlot.Sic, msgPlot.Sac);
    }

    // TBD if a plot is correlated to track make it
    // correlated = true;

    let plotID = plotcount;
    plotcount++;

    let plot: PlotCoreObject = this.createPlot(sensorID, plotID, correlated);
    if (!plot.handleMsg(msgPlot))
      return;
    this.addObject(plot);
  }

  protected createPlot(sensorID: number, sensorPlotID: number, correlated: boolean): PlotCoreObject {
    return new PlotCoreObject(this, sensorID, sensorPlotID, correlated);
  }

  private getPlots(sensorID: number): PlotsPerSensor {
    let plots = this.plotsPerSensor.get(sensorID);
    if (plots == undefined) {
      plots = new PlotsPerSensor();
      this.plotsPerSensor.set(sensorID, plots);
    }
    return plots;
  }

  // defined in IPlotsPool
  getPlot(sensorID, sensorPlotID): PlotCoreObject {
    let plots = this.plotsPerSensor.get(sensorID);
    if (plots && plots.objects.has(sensorPlotID))
      return plots.objects.get(sensorPlotID);
    else
      return null;
  }

  // defined in IObjectsPool
  contextMenuActions(obj: AspObject): number[] {
    return [consts.USER_ACTION_ARO];
  }

  addObject(obj: AspObject) {
    super.addObject(obj);

    let plot = obj as PlotCoreObject;
    let plots = this.getPlots(plot.sensorID);
    plots.objects.set(plot.plotID, plot);
  }

  deleteObject(obj: AspObject) {
    let plot = obj as PlotCoreObject;
    let plots = this.plotsPerSensor.get(plot.sensorID);
    if (plots != undefined) {
      plots.objects.delete(plot.plotID);
      plots.correlated.delete(plot.plotID);
    }

    super.deleteObject(obj);
  }

  canBePicked(action: number, actionObj: AspObject, nextObj: AspObject): boolean {
    if (actionObj == nextObj)
      return false;
    if (action == consts.USER_ACTION_RULER)
      return true;
    return false;
  }

}
